import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es5.js';
import spartaContentManagerUtility from '@sparta.global.utilities/sparta-content-manager-utility/dist/es5.js';
import $ from '@sparta.global.vendors/jquery';

/* global sparta spartaEventsUtility */
/* eslint-disable require-jsdoc */
/* eslint-disable valid-jsdoc */

/*
  TODO:
  1. Footnotes links need unique IDs when duplicated. Order doesn't change?
  2. Rules: Refresh the footnotes if any rules were fired to add/remove content.
  3. Support card dynamic footnotes from Cadets.
*/

var EVENTS = {
  FOOTNOTES_REBUILD: 'FOOTNOTES_REBUILD.footnoteUtility',
  FOOTNOTE_CLICKED: 'FOOTNOTE_CLICKED.footnoteUtility',
  RULE_QUEUECOMPLETE: 'RULE-QUEUECOMPLETE.spartaRulesUtility'
};

/**
 * Utility to manage footnotes. It will find all footnotes on the page, collect footnote content,
 * and write this content to a Footnote section in the Footer. It will also handle scrolling to
 * footnotes on click. When rules add or delete content with footnotes, the utility will refresh
 * footnote content.
 */
var footnoteUtility = /*#__PURE__*/function () {
  function footnoteUtility() {
    _classCallCheck(this, footnoteUtility);
    this.$footnoteSection = null;
    this.$footnoteLinks = null;
    this.footnoteObj = {};
    this.footnoteOrder = [];
    this.init();
  }
  return _createClass(footnoteUtility, [{
    key: "EVENTS",
    get: function get() {
      return EVENTS;
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      this.$footnoteSection = $('.spa-footnotes-section');

      // Exit if the page is missing a Footnote section to write footnotes to.
      if (!this.$footnoteSection.length) {
        return;
      }

      // Set up footnotes and event listeners.
      this.getFootnotes();
      this.updateFootnoteSection();
      this.updateFootnoteLinks();
      this.setupEventListeners();

      // Listen for the rebuild events.
      spartaEventsUtility.sub(this.EVENTS.FOOTNOTES_REBUILD, this.checkForRebuild.bind(this), true);
      spartaEventsUtility.sub(this.EVENTS.RULE_QUEUECOMPLETE, function () {
        $('[data-sparta-container]').on('webkitAnimationEnd oanimationend msAnimationEnd animationend', _this.checkForRebuild());
      }, true);
      spartaEventsUtility.pub('FOOTNOTE_UTIL_RAN', true);
    }

    /**
     * getFootnotes: Search DOM and grab all footnotes
     * This will be called after rules are fired to grab new footnotes.
     * Create footnoteObj to hold footnote data
     * Create footnoteOrder array to hold order
     * @param selector: string - When provided it will search only from the selector. Useful when
     * having multiple section on the page, but each may have different footnotes to be displayed
     */
  }, {
    key: "getFootnotes",
    value: function getFootnotes() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var footnoteObj = {};
      var footnoteOrder = [];
      var footnoteIndex = 0;
      this.$footnoteLinks = $("".concat(selector || 'body', " a[data-footnote]"));
      this.$footnoteLinks.each(function footnoteLink(i) {
        var $this = $(this);

        // Remove whitespace on SUP link
        $this[0].innerHTML = $this[0].innerHTML.trim();

        // Update `data-footnote` to replace `.` since it breaks jQuery logic
        $this.attr('data-footnote', $this.attr('data-footnote').split('.').join('_'));
        $this.attr('id', $this.attr('id').split('.').join('_'));

        // CMS utility actions
        var contentKey = $this.attr('data-content-key');
        var contentRecord = $this.attr('data-content-record-key');
        if (contentKey && contentRecord) {
          var footnoteContentString = "<span data-content-key=\"".concat(contentKey, "\" data-content-record-key=\"").concat(contentRecord, "\"></span>");
          $this.attr('data-content-inject', 'false');
          $this.attr('data-footnote-content', footnoteContentString);
        }
        var thisFn = $this.data() || {};

        // Set a unique ID. Without it, some footnotes may have the same ID.
        var uniqueId = "".concat($this.attr('id'), "_").concat(i);
        $this.attr('id', uniqueId);

        // Get the footnote by ID, and get the ADA text provided if it exists.
        var fn = document.getElementById(uniqueId);
        var adaContainer = fn.querySelector('.ada-hidden');
        var adaText = !adaContainer || adaContainer.innerText === 'adatext' ? null : adaContainer.innerText;
        if (typeof footnoteObj[thisFn.footnote] === 'undefined') {
          thisFn.footnoteIndex = footnoteIndex;
          thisFn.footnoteLinkId = uniqueId;
          thisFn.adaText = adaText;
          footnoteObj[thisFn.footnote] = thisFn;
          footnoteOrder.push(thisFn.footnote);
          footnoteIndex += 1;
        }
      });
      spartaEventsUtility.pub('FOOTNOTE_ELEMENT_CONTENT_GENERATED', this.$footnoteLinks);

      // Set final footnote order and object.
      this.footnoteObj = footnoteObj;
      this.footnoteOrder = footnoteOrder;
    }

    /**
     * updateFootnoteSection
     * Update footnote section with footnote content
     */
  }, {
    key: "updateFootnoteSection",
    value: function updateFootnoteSection() {
      var _this2 = this;
      var newFootnotes = '<ol>';

      // Get the back to content and label text, en and es.
      var ariaLabelBack = this.$footnoteSection.data('ariaLabelBack') ? "aria-label=\"".concat(this.$footnoteSection.data('ariaLabelBack'), "\"") : '';
      this.footnoteOrder.forEach(function (fn) {
        var getFootnoteElm = document.querySelector("[data-footnote=\"".concat(_this2.footnoteObj[fn].footnote, "\"]"));
        if (getFootnoteElm) {
          var getFootnoteContent = getFootnoteElm.getAttribute("data-footnote-content");
          _this2.footnoteObj[fn].footnoteContent = getFootnoteContent;
        }
        var backToContentLink = _this2.$footnoteSection.data('backContent') ? "\n          <a\n            href=\"#".concat(_this2.footnoteObj[fn].footnoteLinkId, "\"\n            ").concat(ariaLabelBack, "\n            class=\"spa-footnote-back\"\n          >").concat(_this2.$footnoteSection.data('backContent'), "</a>\n        ") : '';
        newFootnotes += "\n        <li>\n          <div id=\"ftn_".concat(_this2.footnoteObj[fn].footnote, "_content\" class=\"ftn-wrapper\">\n            ").concat(_this2.footnoteObj[fn].footnoteContent, "\n            ").concat(backToContentLink, "\n          </div>\n        </li>\n      ");
      }, this);
      newFootnotes += '</ol>';

      // insert new footnotes
      this.$footnoteSection.html(newFootnotes);
      this.updateFootnoteContentFromCms(this.footnoteOrder, this.footnoteObj);
    }

    /**
     * getGlobalFootnoteAdaText
     * returns global ADA text based on language
     */
  }, {
    key: "getGlobalFootnoteAdaText",
    value: function getGlobalFootnoteAdaText() {
      try {
        // Since `spaParams` is not available in the store when this utility runs, get it from global.
        var adaText = window.spaParams.global[sparta.language].footnote.adaText || 'Footnote';
        return adaText;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Error fetching footnote global ADA text: ".concat(err));
        return 'Footnote';
      }
    }

    /**
     * updateFootnoteLinks
     * Update footnote links with correct order #
     */
  }, {
    key: "updateFootnoteLinks",
    value: function updateFootnoteLinks() {
      for (var i = 0; i < this.footnoteOrder.length; i += 1) {
        var fnSelector = this.footnoteObj[this.footnoteOrder[i]];
        var $thisFn = $("a[data-footnote=".concat(fnSelector.footnote, "]"));
        var newContent = "\n        <span class=\"ada-hidden\">\n          ".concat(fnSelector.adaText || this.getGlobalFootnoteAdaText(), "\n        </span>&#91;").concat(i + 1, "&#93;\n      ");
        $thisFn.find('span.spa-footnote-order').html(newContent);

        // Set an aria-label to the link, so that it will be read by screen reader.
        var adaText = "".concat(this.getGlobalFootnoteAdaText(), " ") || '';
        var ariaLabelcontent = "".concat(adaText).concat(i + 1);
        $thisFn.attr('aria-label', ariaLabelcontent);
      }
    }

    /**
     * setupEventListeners
     * Click: Toggle open panel if its closed when footnotes are clicked
     * Rules
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      $('body').on('click.footnoteLink', 'a[id^="ftn_"]', function footnoteLinkClick(e) {
        $('.spa-footnote-back').removeClass('spa-footnote-back--show');
        e.preventDefault();
        e.stopPropagation();

        // Publish an event to let consuming components know a footnote was clicked.
        spartaEventsUtility.pub(EVENTS.FOOTNOTE_CLICKED, e);

        // Dynamically point the "back to content" link to the right trigger ID.
        var targetEl = document.querySelector("#ftn_".concat(this.dataset.footnote, "_content"));
        if (targetEl) {
          var backToContentTarget = this.id;
          var backToContentLink = targetEl.querySelector('.spa-footnote-back');
          if (backToContentLink) {
            backToContentLink.setAttribute('href', "#".concat(backToContentTarget));
          }
        }

        // Scroll to the target.
        var $target = $("#ftn_".concat(this.dataset.footnote, "_content"));
        var offset = 60;
        var targetOffset = $target.offset();
        targetOffset = targetOffset ? targetOffset.top - offset : 0;
        var stickyOffset = footnoteUtility.getStickyOffset();
        if (stickyOffset > offset) {
          offset = stickyOffset;
        }
        footnoteUtility.scrollToTarget($target, targetOffset);
      });

      // Set up "back to content" scrolling.
      $('[data-sparta-container]').on('blur.footnoteBack', '.spa-footnote-back', function () {
        $('.spa-footnote-back').removeClass('spa-footnote-back--show');
        $('.spa-footnotes-section .ftn-wrapper').removeAttr('tabindex');
      });
      $('body').on('click.footnoteBack', '.spa-footnote-back', function footnoteBackClick(e) {
        e.preventDefault();
        e.stopPropagation();
        var $backLink = $(this);
        var $footnoteLink = $($backLink.attr('href'));
        if ($footnoteLink.is(':visible')) {
          var linkOffset = $footnoteLink.offset();
          linkOffset = linkOffset ? linkOffset.top - footnoteUtility.getStickyOffset() : 0;
          footnoteUtility.scrollToTarget($footnoteLink, linkOffset);
        }
      });

      // Set up focus events for footnote content.
      $('body').on('focus.footnote', '.spa-footnotes-section .ftn-wrapper', function footnoteFocus() {
        var $backLink = $(this).find('.spa-footnote-back');
        var $footnoteLink = $($backLink.attr('href'));

        // This keeps the "back to content" link from showing if the footnote doesn't have `tabindex`.
        if ($footnoteLink.is(':visible') && this.getAttribute('tabindex')) {
          if ($backLink) $backLink.addClass('spa-footnote-back--show');
        }
      });
    }
  }, {
    key: "checkForRebuild",
    value: function checkForRebuild() {
      var _this3 = this;
      var oldLinks = this.$footnoteLinks;
      var newLinks = [];
      if (!oldLinks) {
        this.rebuildFootnotes();
      } else {
        newLinks = $('a[data-footnote]');
        if (newLinks.length !== oldLinks.length) {
          this.rebuildFootnotes();
        } else {
          for (var i = 0; i < newLinks.length; i += 1) {
            if (newLinks[i] !== oldLinks[i]) {
              this.rebuildFootnotes();
              return;
            }
          }
        }
      }

      // Wait for footnotes HTML to finish altering from getFootnotes function
      spartaEventsUtility.sub('FOOTNOTE_ELEMENT_CONTENT_GENERATED', function (event) {
        _this3.getContentAndInjectFromCMS(event);
      }, true);
    }

    /**
     * To rebuild the footnotes
     * @param selector. If provided, it will build footnotes from the selector
     */
  }, {
    key: "rebuildFootnotes",
    value: function rebuildFootnotes() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.$footnoteSection) {
        this.$footnoteSection.html();

        // Get page footnotes
        this.getFootnotes(selector);

        // Update footnote section with footnote content
        this.updateFootnoteSection();

        // Update footnote section with footnote content
        this.updateFootnoteLinks();
      }
    }

    /**
     * Once CMS response is complete, update the sup link content attribute
     * @param {*} supLinkArray Sup link DOM elements
     * @param {*} footnoteObj Object with footnote information
     */
  }, {
    key: "updateFootnoteContentFromCms",
    value: function updateFootnoteContentFromCms(supLinkArray, footnoteObj) {
      var supLinkElements = [];
      var contentKeyArray = [];
      supLinkArray.forEach(function (fn) {
        // Get sup links
        // Get all since some cases data-footnote has same value in multiple places (like breakpoints)
        var getFootnoteElm = _toConsumableArray(document.querySelectorAll("[data-footnote=\"".concat(footnoteObj[fn].footnote, "\"]")));

        // Loop through, collect, and clean up
        getFootnoteElm.forEach(function (footnoteElm) {
          var contentKey = footnoteElm.getAttribute('data-content-key');
          var contentRecord = footnoteElm.getAttribute('data-content-record-key');

          // Push all keys to an array to setup events for
          if (contentKey) {
            contentKeyArray.push(contentKey);
            supLinkElements.push({
              getFootnoteElm: footnoteElm,
              contentRecord: contentRecord
            });
          }

          // Remove CMS attributes from sup link
          footnoteElm.removeAttribute('data-content-key');
          footnoteElm.removeAttribute('data-content-record-key');
        });
      });
      contentKeyArray = _toConsumableArray(new Set(contentKeyArray));
      contentKeyArray.forEach(function (key) {
        spartaEventsUtility.sub("spartaContentManagerUtility.CMS_Utility_Key_Complete_".concat(key), function (event) {
          var responseData = event.data ? event.data : event.args;
          var content = responseData.content;

          //Handles content error
          if (content) {
            // Loop through sup links and update footnote content attr
            supLinkElements.forEach(function (item) {
              var getFootnoteElm = item.getFootnoteElm,
                contentRecord = item.contentRecord;
              var recordValue;
              if (content) {
                recordValue = contentRecord.split('.').reduce(function (o, i) {
                  return o[i];
                }, content);
              }

              // Update sup link
              if (recordValue) {
                getFootnoteElm.setAttribute('data-footnote-content', recordValue);
              }

              // Update visible content in footer
              var footnoteContent = document.getElementById("ftn_".concat(getFootnoteElm.getAttribute('data-footnote'), "_content"));
              if (footnoteContent && recordValue) {
                var target = footnoteContent.querySelector('[data-content-key]');
                if (target) {
                  target.innerHTML = recordValue;
                  target.removeAttribute('data-content-key');
                  target.removeAttribute('data-content-record-key');
                }
              }
            });
          }
        }, true);
      });
    }

    /**
     * Get content from the CMS and inject it into the footnote
     * @param {*} event Contains response from event
     */
  }, {
    key: "getContentAndInjectFromCMS",
    value: function getContentAndInjectFromCMS(event) {
      // Get footnotes from event
      var footnoteElements = event.data ? event.data : event.args;

      // Convert jQuery element array to vanilla JS
      footnoteElements = $.makeArray(footnoteElements);
      footnoteElements = footnoteElements.filter(function (footnote) {
        var footnoteAttr = footnote.getAttribute('data-footnote-content');
        var footnoteContent = document.getElementById("ftn_".concat(footnote.getAttribute('data-footnote'), "_content"));
        if (footnoteContent && footnoteAttr && footnoteAttr.includes('data-content-key') && footnoteAttr.includes('data-content-record') && footnoteContent.querySelector('[data-content-key]')) {
          var target = footnoteContent.querySelector('[data-content-key]');
          spartaContentManagerUtility.getContentAndInject({
            target: target,
            contentKey: target.getAttribute('data-content-key'),
            contentRecord: target.getAttribute('data-content-record'),
            dynamicTokens: target.getAttribute('data-dynamic-tokens') ? JSON.parse(target.getAttribute('data-dynamic-tokens')) : {},
            options: {
              disableWarning: true
            }
          });
        }
      });
    }
  }], [{
    key: "getStickyOffset",
    value: function getStickyOffset() {
      var stickyOffset = 0;
      $('.spa-sticky').each(function spaStickyOffset() {
        stickyOffset += $(this).outerHeight();
      });
      return stickyOffset;
    }
  }, {
    key: "scrollToTarget",
    value: function scrollToTarget($el, targetOffset) {
      $('html, body').animate({
        scrollTop: targetOffset
      }, 250, function () {
        if ($el.is('.spa-footnotes-section .ftn-wrapper')) {
          $el.attr('tabindex', '-1').focus();
        } else {
          $el.focus();
        }
      });
    }
  }]);
}(); // eslint-disable-next-line new-cap
var index = new footnoteUtility();
export { index as default };